export default "__VITE_ASSET__BQ1HpOgy__"